import React from 'react';
// APOLLO
import { graphql, compose } from 'react-apollo';
import submitQuestionnaire from 'ApolloClient/Mutations/submitQuestionnaire';
import questionnaireByIdQuery from 'ApolloClient/Queries/questionnaireById';
// ANTD
import Card from 'antd/lib/card';
import message from 'antd/lib/message';
import Result from 'components/common/Result';
import Button from 'components/common/Button';
import Form from 'antd/lib/form';
import TextInput from 'components/inputs/TextInput';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';


const FormItem = Form.Item;

export class ClientQuestionnairePage extends React.Component {
  state = {
    results: [],
    loading: false,
    complete: false,
  };

  onSubmit = async () => {
    this.setState({ loading: true });
    const _id = this.props.match.params.questionTemplateId;
    const params = {
      results: this.state.results,
    };


    if (this.state.results.length !== this.props.questionnaireByIdQuery.questionnaireById.questions.length) {
      this.setState({ loading: false });
      return message.error('please fill out all the fields!')
    }

    const variables = { _id, params };
    const refetchQueries = [
      {
        query: questionnaireByIdQuery,
        variables: { _id },
      },
    ];

    try {
      await this.props.submitQuestionnaire({ variables, refetchQueries })
    }
    catch(err){
      this.setState({ loading: false });
      if (err.message) { return message.error(err.message.replace('Graphql', '')); }
      if (err.reason) { return message.error(err.reason); }
    }
    
    message.success('complete!');
    this.setState({ loading: false, complete: true });

  };

  renderItem = (item, index) => {

    return (
      <div key={item}>
        <p>{item}</p>
        <FormItem>
          <TextInput
            size='large'
            onChange={answer => {
              let results = this.state.results;
              results[index] = { question: item, answer };
              this.setState({ results });
            }}
            value={this.state.results[index] ? this.state.results[index].answer : null}
          />
        </FormItem>
      </div>
    );
  };

  renderContent = () => {
    const { questionnaireById } = this.props.questionnaireByIdQuery;
    if (questionnaireById.complete) {
      return (
        <Result
          type="success"
          title="Questionnaire Completed!"
          description="Thanks! Somebody will be in touch with you shortly..."
        />
      );
    }
    return (
      <div>
        {questionnaireById.questions.map((item, index) => this.renderItem(item, index))}
        <Button fullWidth loading={this.state.loading} onClick={this.onSubmit}>
          {!this.state.loading ? 'SUBMIT' : 'SUBMITTING...'}
        </Button>
      </div>
    );
  };

    render() {
        const {  questionnaireById } = this.props.questionnaireByIdQuery;  

        if (!questionnaireById) {
          return <div>We can't find this questionnaire</div>
        }

        return (
            <div style={{
          padding: 4,
          width: 1100,
          maxWidth: '100%',
          margin: 'auto',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        }}>
                <Card
                    loading={this.state.loading}
                    style={{ padding: 4, width: 600, maxWidth: '100%', margin: 'auto' }}
                >
                    <div style={{ textAlign: 'center' }}>
                        {questionnaireById.organization && questionnaireById.organization.image && (
                            <img
                                style={{ textAlign: 'center', maxHeight: 100, margin: '15px auto' }}
                                src={questionnaireById.organization.image}
                                alt="logo"
                            />
                        )}
                    </div>
                    {this.renderContent()}
                </Card>
            </div>
        );
    }
}

let options = props => {
  let _id = props.match.params.questionTemplateId;
  let variables = { _id };
  return {
    variables,
  };
};

export default compose(
  graphql(submitQuestionnaire, { options, name: 'submitQuestionnaire' }),
  graphql(questionnaireByIdQuery, { options, name: 'questionnaireByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'questionnaireByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'questionnaireByIdQuery' }),
)(ClientQuestionnairePage);



// WEBPACK FOOTER //
// ./src/routes/client-questionnaire/index.js